import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';

@Injectable(
  
)
export class HashService {

  headers: Headers;
  options: RequestOptions;
  HASH_SERVICE_URL = 'https://sos.alerto.app/web_Services/NeedlyService.svc/GenerateHashFromJson/HashGenerator';

  constructor(private _http: Http) {
    this.headers = new Headers({ 'Content-Type': 'text/plain; charset=utf-8' });
    this.options = new RequestOptions({ headers: this.headers });
  }

  /**
   * Generates hash by calling the remote hash service directly
   * @param payload Payment payload object
   * @returns Observable with hash response
   */
  generateHash(payload: any): Observable<any> {
    // Validate required fields
    if (!payload.MerchantId || !payload.TxnId || !payload.TotalAmount) {
      return Observable.throw(new Error('Missing required fields: MerchantId, TxnId, TotalAmount'));
    }

    // Convert payload to raw JSON string as the API expects text/plain
    const rawText = JSON.stringify(payload);
    console.log('📤 Sending RAW text to hash service:', rawText);

    return this._http.post(this.HASH_SERVICE_URL, rawText, this.options)
      .map((response: Response) => {
        const responseText = response.text();
        console.log('✅ Hash service raw response:', responseText.slice(0, 500));
        
        // Try to parse the response
        let parsed: any;
        try {
          parsed = JSON.parse(responseText);
        } catch (e) {
          console.warn('Response is not JSON, treating as raw text');
          throw new Error('Invalid response format from hash service');
        }

        // Extract hash from the response structure
        const result = parsed.GenerateHashFromJsonResult || parsed;
        
        if (!result || !result.Hash) {
          console.error('❌ Unexpected response structure:', parsed);
          throw new Error('Hash not found in response');
        }

        console.log('🔐 Hash generated successfully:', result.Hash);
        
        return {
          ok: true,
          hash: result.Hash,
          pipeString: result.PipeString || null,
          algorithm: result.AlgorithmUsed || null
        };
      })
      .catch((error: any) => {
        console.error('❌ Hash service error:', error);
        
        let errorMessage = 'Failed to generate hash';
        
        if (error.error) {
          errorMessage = 'Hash service error: ' + error.error;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        return Observable.throw(new Error(errorMessage));
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/login/services/hash.service.ts